import { render, staticRenderFns } from "./PreviewUpload.vue?vue&type=template&id=5542b25a"
import script from "./PreviewUpload.vue?vue&type=script&lang=js"
export * from "./PreviewUpload.vue?vue&type=script&lang=js"
import style0 from "./PreviewUpload.vue?vue&type=style&index=0&id=5542b25a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports